import { useState } from "react";
import "./index.scss";

export const CollapsibleItem = ({ label, children, keepOpen = false }) => {
  const [isOpen, setIsOpen] = useState(keepOpen);
  const indicator = isOpen ? "-" : "+";
  const handleClick = () => setIsOpen(!isOpen);

  return (
    <div className="collapsible-main">
      <button onClick={handleClick} className="label">
        {label}
      </button>
      <button onClick={handleClick} className="indicator">
        {indicator}
      </button>
      {isOpen && <p className="detail">{children}</p>}
    </div>
  );
};
